<template>
  <el-dialog
    title="跟进人员变更"
    :visible.sync="show"
    top="5vh"
    width="30%"
    custom-class="no-min-height"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :close="closeDialog"
  >
    <el-form :model="formData" :rules="rules" ref="form" label-position="top">
      <el-form-item :label="role" prop="id">
        <ab-person
          v-if="role !== '财务核管'"
          v-model="formData.id"
          :desc="formData.name"
          @change-desc="setName"
          placeholder="请选择"
        ></ab-person>
        <ab-user
          v-else
          v-model="formData.id"
          :desc="formData.name"
          @change-desc="setName"
          placeholder="请选择"
        ></ab-user>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="btnLoading" @click="confirmDialog"
        >提交</el-button
      >
      <el-button @click="closeDialog">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'employeeDialog',
    props: {
      role: {
        type: String,
      },
      show: {
        type: Boolean,
      },
      id: {
        type: Number,
      },
      roleId: {
        type: String,
      },
    },
    data() {
      return {
        btnLoading: false,
        formData: {},
        rules: {
          id: [{ required: true, message: '请选择跟进人员', trigger: 'change' }],
        },
      }
    },
    methods: {
      setName(name) {
        this.$set(this.formData, 'name', name)
      },

      confirmDialog() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.btnLoading = true
            let data = {
              id: this.id,
            }
            data[this.roleId] = this.formData.id
            this.$post('/bas/servProtocol/updateMan', data)
              .then(({ data }) => {
                if (data.code === 'C0000') {
                  this.$message.success(data.message)
                  this.closeDialog()
                }
              })
              .finally(() => {
                this.btnLoading = false
              })
          }
        })
      },

      closeDialog() {
        this.formData = {}
        this.$refs.form.clearValidate()
        this.$emit('update:show', false)
        this.$emit('init')
      },
    },
  }
</script>